import { cn, createBEM } from "@/libs";
import { useLatest, useSetState, useSize } from "ahooks";
import React, { PropsWithChildren, useRef } from "react";
import { Icon } from "@/components/Icon";
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
// import './index.css';

import "./index.scss";
export type MarqueeProps = PropsWithChildren<{
  className?: string;
  icon?: React.ReactNode;
  duration?: number;
}>;
const b = createBEM("i-marquee");
export const Marquee = ({
  children,
  className,
  icon,
  duration = 6000
}: MarqueeProps) => {
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const wrapperSize = useSize(wrapperRef);
  const contentSize = useSize(contentRef);
  const [state, setState] = useSetState({
    x: 0,
    // x 是内容的x轴位置
    ani: false,
    // x 轴走到目标位置时，需要关闭动画并更改x位置为 wrapperSize width
    wrapperWidth: -1,
    contentWidth: -1,
    duration: 0
  });
  const latestState = useLatest(state);
  const resetTransition = () => {
    if (state.ani) {
      setState({
        ani: false,
        x: `${children}`.length * 10,
        duration: duration
      });
    }
    setTimeout(() => setState({
      ani: true,
      x: -latestState.current.contentWidth
    }), 40);
  };
  if (wrapperSize && contentSize && state.x === 0 && children) {
    if (contentSize.width !== 0) {
      setState({
        ani: false,
        x: wrapperSize.width,
        wrapperWidth: wrapperSize.width,
        contentWidth: contentSize.width,
        duration: duration
      });
      resetTransition();
    }
  }
  return <div className={cn(b(), className)} data-sentry-component="Marquee" data-sentry-source-file="index.tsx">
      {icon}
      <div className={b("content-wrapper")} ref={wrapperRef}>
        {children ? <span className={b("content")} ref={contentRef} style={{
        left: state.x === 0 ? undefined : `${state.x}px`,
        transitionDuration: state.ani ? `${state.duration}ms` : "0s",
        whiteSpace: 'nowrap'
      }} onTransitionEnd={resetTransition}>
            {children}
          </span> : "暂无公告"}
      </div>
    </div>;
};
const layout = 60;
const per_offset = 1;
const start_offset = 10;
export const MarqueeContent = ({
  list
}: any) => {
  const containerRef = useRef<any>();
  const itemRef = useRef<any>();
  const timer = useRef<any>(null);
  const left = useRef(0);
  const actions = useRef<any>({});
  const [show, setShow] = useState({
    text: '',
    index: 0
  });
  const [_list, setList] = useState([]);
  const navigate = useNavigate();
  actions.current.calcOffset = useCallback((left: number) => {
    containerRef.current && (containerRef.current.style.transform = `translateX(${left}px)`);
  }, []);
  actions.current.calcLeft = useCallback(() => {
    const _left = left.current - per_offset;
    if (containerRef.current && -_left < containerRef.current.clientWidth) {
      left.current = _left;
      actions.current.calcOffset(_left);
    } else {
      left.current = start_offset;
      actions.current.calcOffset(start_offset);
      const index = show.index + 1;
      if (index === _list.length) {
        setShow({
          text: _list[0],
          index: 0
        });
      } else {
        setShow({
          text: list[index],
          index
        });
      }
    }
  }, [show]);
  actions.current.setInterval = useCallback(() => {
    timer.current = setInterval(() => {
      actions.current.calcLeft();
    }, layout);
    return () => {
      clearInterval(timer.current);
    };
  }, []);
  useEffect(() => {
    if (list !== _list) {
      setList(list);
      setShow({
        text: list[0] || '',
        index: 0
      });
      if (list.length) {
        if (!timer.current) {
          return actions.current.setInterval();
        }
      }
      clearInterval(timer.current);
    }
  }, [list]);
  return <div className='marquee-wrapper' onClick={() => navigate("/messages/notice")} data-sentry-component="MarqueeContent" data-sentry-source-file="index.tsx"> 
      <div className='marquee-item' ref={itemRef}>
        <div ref={containerRef} className='marquee-item-text'>{show.text}</div>
      </div>
      <Icon name={"user-arrow-right"} size={"16px"} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
  </div>;
};
export const MarqueeItem = ({
  list,
  className,
  icon
}: any) => {
  return <div className={cn(b(), className)} data-sentry-component="MarqueeItem" data-sentry-source-file="index.tsx">
  {icon}
  {list.length ? <MarqueeContent list={list} /> : "暂无公告"}
  </div>;
};